export const ACCESS_TOKEN = 'Access-Token'
export const SIDEBAR_TYPE = 'SIDEBAR_TYPE'
export const DEFAULT_THEME = 'DEFAULT_THEME'
export const DEFAULT_LAYOUT_MODE = 'DEFAULT_LAYOUT_MODE'
export const DEFAULT_COLOR = 'DEFAULT_COLOR'
export const DEFAULT_COLOR_WEAK = 'DEFAULT_COLOR_WEAK'
export const DEFAULT_FIXED_HEADER = 'DEFAULT_FIXED_HEADER'
export const DEFAULT_FIXED_SIDEMENU = 'DEFAULT_FIXED_SIDEMENU'
export const DEFAULT_FIXED_HEADER_HIDDEN = 'DEFAULT_FIXED_HEADER_HIDDEN'
export const DEFAULT_CONTENT_WIDTH_TYPE = 'DEFAULT_CONTENT_WIDTH_TYPE'
export const DEFAULT_MULTI_TAB = 'DEFAULT_MULTI_TAB'
export const QUEUE = 'QUEUE'

// queue mutations
export const SET_QUEUE_ITEM = 'SET_QUEUE_ITEM'
export const SET_QUEUE = 'SET_QUEUE'
export const SET_CHART_IMAGE = 'SET_CHART_IMAGE'
export const SET_COMPANIES = 'SET_COMPANIES'
export const SET_METERS = 'SET_METERS'
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY'
export const SET_CURRENT_METER = 'SET_CURRENT_METER'
export const FETCHING_COMPANIES = 'FETCHING_COMPANIES'
export const LOADING_MORE = 'LOADING_MORE'
export const FETCHING_METERS = 'FETCHING_METERS'
export const SET_DATE_ON = 'SET_DATE_ON'
export const SET_TIME_ON = 'SET_TIME_ON'
export const SET_DATE_OFF = 'SET_DATE_OFF'
export const SET_TIME_OFF = 'SET_TIME_OFF'
export const SET_BATCH_DETAIL = 'SET_BATCH_DETAIL'
export const SET_QUEUE_PAGE = 'SET_QUEUE_PAGE'
export const SET_QUEUE_MAX_PAGE = 'SET_QUEUE_MAX_PAGE'
export const SET_SAVE_STATUS = 'SET_SAVE_STATUS'
export const SET_QUEUE_DATA = 'SET_QUEUE_DATA'
export const SET_METER_DETAIL = 'SET_METER_DETAIL'
export const SET_IS_SAVING = 'SET_IS_SAVING'
export const RESET_METADATA = 'RESET_METADATA'
export const SET_METER_VOLUMETRIC = 'SET_METER_VOLUMETRIC'
export const SET_NIL_CHART = 'SET_NIL_CHART'
export const RESET_CURRENT_QUEUE_INDEX = 'RESET_CURRENT_QUEUE_INDEX'
export const INCREMENT_CURRENT_QUEUE_INDEX = 'INCREMENT_CURRENT_QUEUE_INDEX'
export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}
export const SET_EXCLUDE_CHART = 'SET_EXCLUDE_CHART'
